module.exports = __webpack_public_path__ + "img/logo_arit.2567cac6.png";